<template>
    <transition name="register" mode="out-in">
        <router-view :form="form"/>
    </transition>
</template>

<script>
import uuid from 'uuid/v4'
import Create from './Create'
import ConfirmEmail from './Create/ConfirmEmail'
import TeamName from './Create/TeamName'
import InviteTeam from './Create/InviteTeam'
import LetsGo from './LetsGo'
import VueRouter from 'vue-router'
import Form from '../../helpers/Form'

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/create',
            component: Create,
            children: [
                { path: 'confirm-email', component: ConfirmEmail, meta: { id: uuid(), image: 'checking-phone.svg', title: 'You got <span>mail</span>' } },
                { path: 'team', component: TeamName, meta: { id: uuid(), image: 'discussion.svg', title: 'Your team <span>name</span>?' } },
                { path: 'invite', component: InviteTeam, meta: { id: uuid(), image: 'sitting-down-working.svg', title: 'Invite your <span>team</span>' } }
            ]
        },
        {
            path: '/lets-go',
            component: LetsGo,
            name: 'lets-go',
            props: true
        }
    ]
})

export default {
    name: 'Register',

    router,

    props: {
        email: {
            require: true,
            type: String
        }
    },

    data () {
        return {
            form: new Form({
                code: '',
                email: this.email,
                team_name: '',
                team_url: '',
                team_size: '',
                skip_invites: false,
                invites: []
            })
        }
    },

    created () {
        this.$router.push('/create/confirm-email')
    }
}
</script>
